<div class="container">
  @if (showSpinner && ((spinnerState$ | async)?.active === true || loading)) {
    <div class="spinner-container">
      <ion-spinner name="crescent" appSafariAnimate></ion-spinner>
      <p>Loading chat...</p>
    </div>
  } @else {
    @if (loadFailReason) {
      <div class="load-failed-container">
        <p class="error">
          We weren't able to load the chat this time.<br /><br />Please check your wifi or mobile data connection and try
          again.
        </p>
        <ion-button type="button" color="secondary" class="ph-btn retryButton" (click)="onRetryLoad()">Try again</ion-button>
      </div>
    }
  }
</div>
